import { render, staticRenderFns } from "./mapLegendPopover.vue?vue&type=template&id=4bb4d1e6&scoped=true&"
import script from "./mapLegendPopover.vue?vue&type=script&lang=js&"
export * from "./mapLegendPopover.vue?vue&type=script&lang=js&"
import style0 from "./mapLegendPopover.vue?vue&type=style&index=0&id=4bb4d1e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb4d1e6",
  null
  
)

export default component.exports